import React from 'react';
import { Link } from 'react-router-dom';
import { secondaryServices } from '../data';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6 text-center lg:text-left"
        >
          <div className="max-w-2xl mx-auto lg:mx-0">
            <h2 className="text-sky-500 font-bold tracking-widest uppercase text-sm mb-4">Mere end bare coating</h2>
            <h3 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight uppercase">
              Vi tilbyder komplet <span className="text-sky-500">bilpleje</span>
            </h3>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {secondaryServices.slice(0, 3).map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative h-[450px] overflow-hidden rounded-[2.5rem] bg-slate-100 transition-all shadow-lg hover:shadow-2xl"
            >
              <img 
                src={service.image} 
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent" />
              
              <div className="absolute bottom-0 left-0 w-full p-8">
                <h4 className="text-2xl font-bold text-white mb-3 uppercase">{service.title}</h4>
                <p className="text-slate-300 mb-6 line-clamp-2">{service.description}</p>
                <Link 
                  to={`/service/${service.slug}`}
                  className="inline-flex items-center gap-2 text-white font-bold hover:text-slate-300 transition-colors"
                >
                  Læs mere
                  <ChevronRight size={20} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
